module.exports = __webpack_public_path__ + "img/steps_3.d128aa57.png";